/* eslint-disable sonarjs/no-identical-functions */
const preLoad = (state, payload) => ({
    ...state,
    walletExists: payload.walletExists,
    hasPassphraseSet: payload.hasPassphraseSet,
    isRestoring: payload.isRestoring,
});
const load = (state, payload) => ({
    ...state,
    isLoading: false,
    walletExists: payload.walletExists,
    hasPassphraseSet: payload.hasPassphraseSet,
    isRestoring: payload.isRestoring,
});
const create = (state, payload) => ({
    ...state,
    isLoading: false,
    walletExists: payload.walletExists,
    hasPassphraseSet: payload.hasPassphraseSet,
    isRestoring: payload.isRestoring,
});
const importCompleted = (state, payload) => ({
    ...state,
    isLoading: false,
    walletExists: payload.walletExists,
});
const lock = (state) => ({
    ...state,
    isLocked: true,
});
const unlock = (state) => ({
    ...state,
    isLocked: false,
});
const locked = (state, payload) => ({
    ...state,
    isLocked: payload,
});
const backedUp = (state, payload) => ({
    ...state,
    isBackedUp: payload,
});
const backup = (state) => ({
    ...state,
    isBackedUp: true,
});
const restore = (state, payload) => ({
    ...state,
    walletExists: state.walletExists || Boolean(payload),
    isRestoring: payload,
});
const restoreCompleted = (state) => ({
    ...state,
    isRestoring: false,
});
const passphraseChanged = (state) => ({
    ...state,
    hasPassphraseSet: true,
});
const lockHistory = (state, payload) => ({
    ...state,
    lockHistory: payload.filter((it) => it.locked),
});
const autoLockTimer = (state, payload) => ({
    ...state,
    autoLockTimer: payload,
});
const walletCreatedAt = (state, payload) => ({
    ...state,
    walletCreatedAt: payload,
});
const eventReducers = {
    'pre-load': preLoad,
    load,
    create,
    'import-completed': importCompleted,
    lock,
    unlock,
    locked,
    backedUp,
    backup,
    restore,
    'restore-completed': restoreCompleted,
    'passphrase-changed': passphraseChanged,
    lockHistory,
    autoLockTimer,
    walletCreatedAt,
};
export default eventReducers;
